import React from "react"
import { useAtom } from "jotai";
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from "./CommonHeaderRight";
import Navigation from '../../../layout/Navigation/Navigation';
import { purchasePagesMenu } from "../../../menu";
import useDeviceScreen from "../../../hooks/useDeviceScreen";
import { purchaseAtom } from "../../../_atoms/localAtoms";
import CommonHeaderLeft from "./CommonHeaderLeft";

const PurchaseHeader = () => {
	const [purchase] = useAtom(purchaseAtom)
	const { width } = useDeviceScreen();

	return (
		<Header>
			<HeaderLeft>
				{purchase && purchase._id
					? <Navigation
						menu={purchasePagesMenu}
						id={`${purchasePagesMenu.general.id}top-menu`}
						horizontal={
							!!width && width >= Number(process.env.REACT_APP_MOBILE_BREAKPOINT_SIZE)
						}
					/>
					: <CommonHeaderLeft />
				}
			</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default PurchaseHeader;
